export default {
    namespaced: true,
    state: () => ({
        user : {
            type : '',
            info : '',
        }
    }),
    getters: {
        data(state) {
            return state.user
        },
        info (state) {
           return window.btoa(unescape(encodeURIComponent(state.user.info)))
        },
        type (state) {
           return state.user.type
        },
    },
    mutations: {
        setUser(state, payload) {
            state.user = payload
        },
    },
    actions: {
        setUser({ commit }, user) {
            commit('setUser', user )
        },
    },
}
